import { WeeklyOperatingHours, DayOperatingHours } from '@/components/common/WeeklyOperatingHours';

interface StoreOperatingHoursProps {
  operatingHours: DayOperatingHours[];
  onOperatingHoursChange: (hours: DayOperatingHours[]) => void;
  className?: string;
}

export function StoreOperatingHours({ 
  operatingHours, 
  onOperatingHoursChange, 
  className = '' 
}: StoreOperatingHoursProps) {
  
  return (
    <div className={`space-y-6 ${className}`}>
      <div>
        <h3 className="text-[20px] font-semibold text-[#222222] mb-6">영업시간</h3>
        <div className="bg-gray-50 p-6 rounded-lg border">
          <WeeklyOperatingHours
            operatingHours={operatingHours}
            onChange={onOperatingHoursChange}
          />
        </div>
      </div>

      {/* 안내 메시지 */}
      <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
        <p className="text-[14px] text-blue-600">
          <strong>💡 안내:</strong> 최소 하루 이상의 영업시간을 설정해주세요. 휴무일이 있는 경우 해당 요일의 '휴무' 버튼을 클릭하세요.
        </p>
      </div>
    </div>
  );
}